export default __webpack_public_path__ + "static/media/WWYK.991e49b4.gif";